// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "ffe80c02d9354a04c40d" + ".chunk.js";
};